import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Form, Popover, Switch, Modal, Divider } from 'antd';
import CustomInput from '../../common/Input';
import { getSignByProfitType } from '../../../utils/parsers';
import IconSvg from '../../common/IconSvg';

const FormItem = styled(Form.Item)`
  margin: 5px;
  & label {
    font-weight: 400 !important;
  }
`;

// const radioStyle = {
//   display: 'block',
//   height: '30px',
//   lineHeight: '30px',
// };

@inject('settingsStore')
@injectIntl
@Form.create()
@observer
class Orders extends Component {
  componentDidMount() {
    this.props.updateBreadcrumbs(
      {
        name: this.props.intl.formatMessage({ id: 'settingsModal.orders' }),
      },
      true,
    );
  }

  // eslint-disable-next-line consistent-return
  getRadioIcon = status => {
    if (status === 'Process all orders with BIFM')
      return (
        <span>
          {status}{' '}
          <Popover
            arrowPointAtCenter
            placement="bottom"
            title={null}
            content="By selecting this option we will re-price all the items below $25 and will add a fixed shipping price of $5.99 to the item price."
          >
            <IconSvg type="info" size={16} style={{ verticalAlign: 'text-top' }} />
          </Popover>
        </span>
      );
    return status;
  };

  getModalContent = (oldValue, newValue) => {
    if (oldValue === 'Process all orders with BIFM')
      return 'Please notice! By selecting this option we will re-price all of your items below $25 and will remove a fixed shipping price of $5.99 from the calculated price.\n\nThe re-price will be completed within 2-4 hours.';
    if (newValue === 'Process all orders with BIFM')
      return 'Please notice! By selecting this option we will re-price all of your items below $25 and will add a fixed shipping price of $5.99 to the item’s price.\n\nThe re-price will be completed within 2-4 hours.';
    if (
      oldValue === 'Process only orders above $25' &&
      newValue === 'Do not process any orders with BIFM'
    )
      return "Please note, on this option we will not process orders for you automatically. Tracking number and Return features won't be available as well.";
    if (
      oldValue === 'Do not process any orders with BIFM' &&
      newValue === 'Process only orders above $25'
    )
      return 'Please note that by selecting this option, we will process orders of $25 and above.';
    return 'Are you sure you want to change this setting?';
  };

  handleShippingStatusChange = newValue => {
    const {
      settingsStore: {
        orders: { updateShippingStatus, preferedShippingStatus },
      },
      form,
    } = this.props;
    const modalContent = this.getModalContent(preferedShippingStatus, newValue);
    return Modal.confirm({
      title: 'Confirm Change',
      content: modalContent,
      onOk: () => updateShippingStatus(newValue),
      onCancel: () => form.setFieldsValue({ preferedShippingStatus }),
    });
  };

  connectToSaveButton = inputHandler => inputValue => {
    inputHandler(inputValue.target ? inputValue.target.value : inputValue);
    const { updateApplyBtn } = this.props;
    updateApplyBtn();
  };
  render() {
    const {
      intl,
      form,
      ordersClone,
      settingsStore: {
        userProfile: { defaultCurrencyId },
        // orders: { shippingPreferenceStatusses, preferedShippingStatus },
      },
    } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
    };

    const currencySymbol = getSignByProfitType(2, defaultCurrencyId);

    return (
      <React.Fragment>
        <Form layout="vertical">
          <FormItem
            {...formItemLayout}
            label={intl.formatMessage({ id: 'orders.maximumPurchaseLimit' })}
          >
            {getFieldDecorator('maximumPurchaseAmount', {
              initialValue: ordersClone.maximumPurchaseLimit,
              rules: [
                {
                  required: false,
                },
                { max: 70 },
                {
                  pattern: /^\d+$/,
                  message: intl.formatMessage({ id: 'userProfile.invalidNotNumber' }),
                },
              ],
            })(
              <CustomInput
                type="text"
                onChange={this.connectToSaveButton(ordersClone.setMaximumPurchaseLimit)}
                prefix={currencySymbol}
                css={css`
                  display: flex;
                  & > input {
                    padding-left: 11px !important;
                  }
                  & > span.ant-input-prefix {
                    left: -21px;
                  }
                `}
              />,
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={intl.formatMessage({ id: 'orders.negativeProfitLimit' })}
          >
            {getFieldDecorator('negativeProfitLimit', {
              initialValue: ordersClone.negativeProfitLimit,
              rules: [
                {
                  required: false,
                },
                { max: 70 },
                {
                  pattern: /^\d+$/,
                  message: intl.formatMessage({ id: 'userProfile.invalidNotNumber' }),
                },
              ],
            })(
              <CustomInput
                type="text"
                onChange={this.connectToSaveButton(ordersClone.setNegativeProfitLimit)}
                prefix={currencySymbol}
                css={css`
                  display: flex;
                  & > input {
                    padding-left: 11px !important;
                  }
                  & > span.ant-input-prefix {
                    left: -21px;
                  }
                `}
              />,
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label={intl.formatMessage({ id: 'orders.preferUsedLikeNew' })}
          >
            <Popover
              title={null}
              content={
                <span
                  css={css`
                    white-space: pre-wrap;
                  `}
                >
                  {this.props.intl.formatMessage({ id: 'orders.preferUsedLikeNewDescription' })}
                </span>
              }
              placement="bottom"
              trigger="hover"
            >
              {getFieldDecorator('preferUsedLikeNew', {
                valuePropName: 'checked',
                initialValue: ordersClone.preferUsedLikeNew,
              })(<Switch onChange={this.connectToSaveButton(ordersClone.setPreferUsedLikeNew)} />)}
            </Popover>
          </FormItem>
          <Divider />
          {/* <FormItem
            {...formItemLayout}
            label={
              <b>
                Shipping Preference <Tag color="green">NEW</Tag>
              </b>
            }
            css={css`display:none;`}
          >
            {getFieldDecorator('preferedShippingStatus', {
              initialValue: preferedShippingStatus,
            })(
              <Radio.Group onChange={e => this.handleShippingStatusChange(e.target.value)}>
                {shippingPreferenceStatusses &&
                  shippingPreferenceStatusses.map(status => (
                    <Radio key={status} style={radioStyle} value={status}>
                      {this.getRadioIcon(status)}
                    </Radio>
                  ))}
              </Radio.Group>,
            )}
          </FormItem> */}
        </Form>
      </React.Fragment>
    );
  }
}

Orders.propTypes = {
  // settingsStore: PropTypes.object,
  intl: PropTypes.object,
  updateBreadcrumbs: PropTypes.func,
  form: PropTypes.object,
  updateApplyBtn: PropTypes.func,
  ordersClone: PropTypes.object,
  settingsStore: PropTypes.object,
};

export default Orders;
